export interface Segment {
  id:number
  name:string
}

export const compareSegmentWith = (o1: Segment, o2: Segment) => {
  if (!o1 || !o2) {
    return o1 === o2;
  }
  return o1.id === o2.id;
}
